// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"495":"31d6cfe0","966":"31d6cfe0"}[chunkId] + ".chunk.css";
};